import { Link } from "react-router-dom";

// material-ui
import { ButtonBase } from "@mui/material";

// project imports
import Logo from "ui-component/Logo";
import LogoSidebar from "ui-component/LogoSidebar";


// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
  <ButtonBase
    disableRipple
    component={Link}
    to="/pages/security/login/Login"
  ><LogoSidebar /></ButtonBase>
);

export default LogoSection;
